import React from 'react';
import { Navbar } from './components/Navbar';
import { Home } from './pages/Home';
import { Footer } from './components/Footer';
export function App() {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Home data-id="element-3" />
      </main>
      <Footer data-id="element-4" />
    </div>;
}